export default __webpack_public_path__ + "static/media/Draft Icon.3c616fee.svg";